import { HeroSection } from '../components/home/HeroSection';
import { EidCountdown } from '../components/EidCountdown';
import { TrustBanner } from '../components/home/TrustBanner';
import { CategoriesSection } from '../components/home/CategoriesSection';
import { TopGiftsSection } from '../components/home/TopGiftsSection';
import { SocialProofSection } from '../components/home/SocialProofSection';
import { EmotionalCTA } from '../components/home/EmotionalCTA';
import { ContentHubSection } from '../components/home/ContentHubSection';
import { SEOHead } from '../components/SEOHead';
import ComingSoonPage from './ComingSoonPage';

const isProduction = () => {
  const host = window.location.hostname;
  return host === 'eidgeschenke.de' || host === 'www.eidgeschenke.de';
};

export default function HomePage() {
  if (isProduction()) {
    return <ComingSoonPage />;
  }

  return (
    <main data-testid="home-page">
      <SEOHead
        title={null}
        description="Einzigartige Eid Geschenke, liebevoll verpackt & schnell geliefert. Handverlesene Geschenkideen für Familie, Kinder, Frauen und Männer zu Eid ul Fitr und Eid ul Adha."
        canonical="/"
      />
      <HeroSection />
      <TrustBanner />
      <EidCountdown />
      <CategoriesSection />
      <TopGiftsSection />
      <SocialProofSection />
      <EmotionalCTA />
      <ContentHubSection />
    </main>
  );
}
